<!-- Movement icons (pilot / tugboats / boatment / etc. ) -->
<div class="d-none d-md-block text-muted" [id]="'movement-summary-icons-' + berthVisit.id">
  <!-- Movement duration -->
  <app-movement-duration-summary [currentBerthVisit]="berthVisit"></app-movement-duration-summary>

  <!-- Vessel draft -->
  @if (!berthVisitInfo?.harbourMasterInfo?.vesselDraught ? berthVisit.nextMovement.vesselDraft :
    berthVisitInfo.harbourMasterInfo.vesselDraught; as draft) {
    <span title="{{draft}} m vessel draft" class="me-3">
      <span class="fa fa-fw fa-ruler-vertical me-1"></span>{{ draft }} m</span>
    }

    <!-- Pilot service -->
    @if (berthVisit.nextMovement.pilotService?.required) {
      <span title="Pilot service" class="me-3">
        <span class="far fa-fw fa-compass me-1"></span>
        {{
        berthVisitInfo?.harbourMasterInfo?.pilotFromDistance === 'ACCEPTED' ? 'Shore based pilotage (LOA)'
        : berthVisit.nextMovement.pilotService.serviceProvider?.name
        }}
        @if (berthVisitInfo?.harbourMasterInfo?.pilotFromDistance === 'ACCEPTED') {
          <span
          class="far fa-fw fa-check me-1 text-portbase-green" title="Shore based pilotage accepted"></span>
        }
        @if (berthVisitInfo?.harbourMasterInfo?.pilotFromDistance === 'NOT_ACCEPTED') {
          <span
          class="far fa-fw fa-xmark me-1 text-portbase-red" title="Shore based pilotage not accepted"></span>
        }
      </span>
    }

    <!-- FROM BERTH -->
    @if (berthVisit.tugboatAtDeparture?.requiredQuantity || berthVisit.boatmenAtDeparture?.required || berthVisit.helmsmenAtDeparture?.required) {
      <span class="me-3">
        <!-- Tugboats from berth -->
        @if (berthVisit.tugboatAtDeparture?.requiredQuantity) {
          <span class="me-3">
            <app-tugboats-summary [currentBerth]="berthVisit" [title]="'Tugboats at departure'"></app-tugboats-summary>
          </span>
        }
        <!-- Boatmen from berth -->
        @if (berthVisit.boatmenAtDeparture?.required) {
          <span title="Boatmen from berth">
            <span class="fa fa-fw fa-link me-1"></span>{{berthVisit.boatmenAtDeparture.serviceProvider?.name}}
          </span>
        }
        <!-- Helmsmen from berth -->
        @if (berthVisit.helmsmenAtDeparture?.required) {
          <span title="Helmsmen from berth">
            <span class="fa fa-fw fa-dharmachakra me-1"></span>{{berthVisit.helmsmenAtDeparture.serviceProvider?.name}}
          </span>
        }
      </span>
    }

    <!-- TO NEXT BERTH -->
    <span>
      <!-- Tugboats to next berth -->
      @if (differentTugs) {
        <span class="me-3">
          <app-tugboats-summary [currentBerth]="berthVisit" [title]="'Tugboats at arrival'" [atArrival]="true">
          </app-tugboats-summary>
        </span>
      }
      <!-- Boatmen to next berth -->
      @if (differentBoatmen) {
        <span>
          <app-boatmen-to-berth-summary [currentBerth]="berthVisit"></app-boatmen-to-berth-summary>
        </span>
      }
      <!-- Helmsmen to next berth -->
      @if (differentHelmsmen) {
        <span>
          <app-helmsmen-to-berth-summary [currentBerth]="berthVisit"></app-helmsmen-to-berth-summary>
        </span>
      }
    </span>
  </div>
